import { useMemo } from "react";
import { ELEMENT_CATEGORIES } from "../ElementsList/useCategorizedElementsList";
import { isComponentExport } from "../Helpers/typePredicates";
import { useBuilderStore } from "./useBuilderStore";

export const useReusableEligibleBlockTypes = () => {
  const blockMapping = useBuilderStore(state => state.blockMapping);

  return useMemo(() => {
    const eligibleTypes = new Set<string>();

    Object.entries(blockMapping).forEach(([type, block]) => {
      if (type === "root") {
        return;
      }

      const categories = block.meta?.category ?? [];
      const hasElementCategory = categories.some(
        category =>
          category?.name && ELEMENT_CATEGORIES.includes(category.name),
      );

      let hasChildrenProp = false;

      if (isComponentExport(block)) {
        const props = block.meta?.props ?? {};
        hasChildrenProp = Object.values(props).some(
          prop => prop?.type === "children",
        );
      }

      if (!hasElementCategory || hasChildrenProp) {
        eligibleTypes.add(type);
      }
    });

    return eligibleTypes;
  }, [blockMapping]);
};
